import { useUserStore } from '@/stores/user';
import profileStore from '@/stores/profiles';
import Avatar from '@/components/Avatar/Avatar.vue';
import { MARKED_AS_UNREAD } from '@/stores/conversations';
const __default__ = {
    components: { Avatar },
    props: {
        conversation: { type: Object, default: () => ({}) },
        size: { type: Number, default: 35 },
    },
    computed: {
        loggedinUser() {
            return useUserStore().getUser;
        },
        users() {
            const lastId = this.conversation?.lastMessage?.authorId;
            const members = this.conversation.members
                // without ourselve
                .filter(m => m !== this.loggedinUser?.id)
                // bring last participant to the top
                .sort((a, b) => {
                if (a === lastId)
                    return -1;
                if (b === lastId)
                    return 1;
                return 0;
            })
                // we dont need more then 4
                .slice(0, 4);
            return members.map((userId, index) => ({
                size: this.getSize(index, members.length),
                // TODO Typecast is obsolete once profile store uses typescript
                ...profileStore.profiles[userId],
            }));
        },
        gridCols() {
            return this.users.length > 1 ? 2 : 1;
        },
        gridRows() {
            return this.users.length > 2 ? 2 : 1;
        },
        avatarSize() {
            return this.size / this.gridRows;
        },
        badgeContent() {
            if (!this.conversation?.unreadMessages)
                return false;
            if (this.conversation.unreadMessages === MARKED_AS_UNREAD)
                return true;
            if (this.conversation.unreadMessages > 99)
                return '99+';
            return this.conversation.unreadMessages.toString();
        },
    },
    methods: {
        getSize(index, total) {
            return index + total < 4 ? this.size : this.size / 2;
        },
    },
};
import { useCssVars as _useCssVars } from 'vue';
const __injectCSSVars__ = () => {
    _useCssVars((_vm, _setup) => ({
        "3c6c92b0": (_vm.gridCols),
        "7709205a": (_vm.size / _vm.gridCols + 'px'),
        "3c5eece4": (_vm.gridRows),
        "465aa3a6": (_vm.size / _vm.gridRows + 'px')
    }));
};
const __setup__ = __default__.setup;
__default__.setup = __setup__
    ? (props, ctx) => { __injectCSSVars__(); return __setup__(props, ctx); }
    : __injectCSSVars__;
export default __default__;
